import { IContentApiClient, KnowledgeFilter, IKnowledgeFilter, IKnowledge, IKnowledgePage } from '@cyber-range/cyber-range-api-content-client';
import { useApiClientStore } from './apiClientStore';
import { defineStore } from 'pinia';

export const useKnowledgeStore = defineStore('knowledgeStore', 
{
    state: () =>
    ({
        knowledgePromise: undefined as Promise<IKnowledge[]>|undefined
    }),
    getters:
    {
        getKnowledges():Promise<IKnowledge[]>
        {  
            return this.knowledgePromise;
        }
    },
    actions:
    {
        clearPromise(): void
        {
            this.knowledgePromise = undefined;
        },

        async fetchKnowledges(): Promise<void> 
        {
            const promise = async ():Promise<IKnowledge[]> =>
            {
                let client: IContentApiClient = useApiClientStore().backgroundContentApiClient;
                let page: IKnowledgePage;
                let knowledges: IKnowledge[] = [];
                let filter: IKnowledgeFilter = new KnowledgeFilter(undefined, undefined, 2000);

                do
                {
                    page = await client.getKnowledges(filter);
                    filter.token = page.nextPageToken;
                    knowledges = knowledges.concat(page.knowledges);
                }
                while (filter.token)

                return knowledges;
            };

            if(!this.knowledgePromise)
            {
                this.knowledgePromise = promise().catch(e=> this.clearPromise());
            }
        },
    }
});